import { createAction, props } from '@ngrx/store';
import { ValidateContactInfoRequest } from '../models/validate-contact-info-request';
import { ProfileComponent } from './profile-component.state';
import { ValidateRTOComponentRequest } from '../models/validate-rto-component-request';

export const loadCandidateProfileComponents = createAction(
    '[Candidate Profile] Load All Components',
    props<{ candidateId: number }>()
);

export const loadCandidateProfileComponentsSuccess = createAction(
    '[Candidate Profile] Load Components Successful',
    props<{ profileComponents: ProfileComponent[] }>()
);

export const loadCandidateProfileComponentsFailure = createAction(
    '[Candidate Profile] Load Components Failure',
    props<{ error: any }>()
);

export const loadShouldDisplayCandidateProfileComponents = createAction(
    '[Candidate Profile] Load Should Display Candidate Profile Components',
    props<{ candidateId: number }>()
);

export const loadShouldDisplayCandidateProfileComponentsSuccess = createAction(
    '[Candidate Profile] Load Should Display Candidate Profile Components Success',
    props<{ allowProfileComponentsView: boolean }>()
);

export const loadShouldDisplayCandidateProfileComponentsFailure = createAction(
    '[Candidate Profile] Load Should Display Candidate Profile Components Failure',
    props<{ error: any }>()
);

export const verifyContactInfoComponents = createAction(
    '[Candidate Personal Info Edit] Verify Contact Info Components',
    props<{ verifyContactInfoRequest: ValidateContactInfoRequest }>()
);

export const verifyContactInfoComponentsFailure = createAction(
    '[Candidate Personal Info Edit] Verify Contact Info Components Failure',
    props<{ error: any }>()
);

export const verifyRTOComponent = createAction(
    '[Job Preference Edit] Verify RTO Dates',
    props<{ validateRTOComponentRequest: ValidateRTOComponentRequest }>()
);

export const verifyRTOComponentFailure = createAction(
    '[Job Preference Edit] Verify RTO Dates Failure',
    props<{ error: any }>()
);

export const showMaxEducationEntriesReachedError = createAction(
    '[Candidate Profile Education] Show Max Education Entries Reached Error'
);
